import View from './Profile'
import { connect } from 'react-redux'
import { componentDidMount, componentWillUnmount } from '../../components/Lifecycles'
import { clear, init } from '../../store/modules/profile'
import { compose, pipe } from 'ramda'

const mapStateToProps = state => ({
  locale: state.router.locale,
  createdAt: state.session.user.createdAt,
  ready: state.profile.isReady,
  user: state.session.user,
})

const mapDispatchToProps = dispatch => ({
  clear: compose(dispatch, clear),
  init: compose(dispatch, init),
})

// didMount :: Props -> Action INIT
const didMount = ({ init, user }) => init(user)

// willUnmount :: Props -> Action CLEARq
const willUnmount = ({ clear }) => clear()

// lifecycles :: React.Component -> React.Component
const lifecycles = pipe(
  componentDidMount(didMount),
  componentWillUnmount(willUnmount),
)(View)

const Profile = connect(mapStateToProps, mapDispatchToProps)(lifecycles)

export default Profile
